export default "__VITE_ASSET__8a77a438__"